<template lang="html">
  <div class="accordion-inner-wrap">
    <div class="accordion-inner-mask">
      <div class="accordion-inner-content">
        <h4 @click="toggleOpen" v-html="data.row_title"></h4>
        <p v-html="data.row_text"></p>
        <div class="download-wrap">
          <IconDownload v-for="(icons, index) in data.row_downloads" 
            :key="index"
            :name="data.row_downloads[index].download_text"
            :link="data.row_downloads[index].download_link" 
          />
        </div>
      </div>
      <div class="read-more" >
        <p @click="toggleOpen">| {{ $t("message.read_more") }}</p>
      </div>
      <div class="accordion-inner-icon">
        <div class="icon-wrap" @click="toggleOpen"></div>
      </div>
    </div>
  </div>
</template>

<script>
import IconDownload from './IconDownload.vue';

export default {
  name: 'AccordionInner',
  props: ['data', 'activeProd', 'indexOrder', 'canToggle'],
  components: {
    IconDownload
  },
  methods: {
    toggleOpen(event){

      if(!this.canToggle) return;
      let parent = event.currentTarget.parentNode.parentNode;
      
      if(parent.classList.contains('open')){
        parent.classList.remove('open');
        return;
      }else{
        let siblingSelected = document.querySelector('.accordion-inner-mask.open');
        if(siblingSelected) siblingSelected.classList.remove('open')
        parent.classList.toggle('open')
      }

      this.$emit('update:activeProd', this.indexOrder);
      
    }
  }
}
</script>

<style lang="scss" scoped>
  .accordion-inner-wrap{
    position: relative;
    width: 100%;
    border-bottom: 1px solid rgba($color: #707070, $alpha: 0.1);
    margin-bottom: 35px;
    padding-bottom: 30px;
  }
  .accordion-inner-content{
    position: relative;
    h4{
      font-size: 20px;
      line-height: 30px;
      @media screen and (max-width: 900px){
        font-size: 22px;
        line-height: 30px;
      }
    }
    p{
      line-height: 30px;
      margin-top: 30px;
      @media screen and (max-width: 900px){
        font-size: 12px;
        line-height: 22px;
      }
    }
    .download-wrap{
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 30px 0 0;
    }
    @media screen and (max-width: 900px){
      flex: auto;
      max-width: 100%;
    }
  }
  .read-more{
    flex: 1 0 90px;
    align-self: flex-end;
    line-height: 30px;
    color: rgba(0,0,0,.35);
    opacity: 1;
    cursor: pointer;
    transition: opacity .2s ease-out;
    @media screen and(max-width: 900px) {
      font-size: 12px;
      line-height: 20px;
      display: none;
    }
  }
  .accordion-inner-icon{
    flex: 1 0 100px;
    max-width: 100px;
    text-align: right;
    transform: rotate(0);
    .icon-wrap{
      position: relative;
      width: 20px;
      height: 20px;
      margin-right: 0;
      margin-left: auto;
      cursor: pointer;
      transition: transform .5s ease-in-out;
      &::before,&::after{
        content: '';
        position: absolute;
      }
      &::before{
        left: 0;
        top: 50%;
        width: 20px;
        transform: translateY(-1px);
        border-bottom: 2px solid #33586E;
      }
      &::after{
        top: 0;
        left: 50%;
        height: 20px;
        transform: translateX(-1px);
        border-left: 2px solid #33586E;
        opacity: 1;
        transition: opacity .35s ease-in-out;
      }
    }
    @media screen and (max-width: 900px){
      flex: 1 0 20px;
      margin-top: 6px;
    }
  }
  .accordion-inner-mask{
    position: relative;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    max-height: 90px;
    transition: max-height .5s ease-in-out;
    @media screen and (max-width: 900px){
      max-height: 82px;
    }
    &.open{
      max-height: 800px;
      .read-more{
        opacity: 0;
      }
      .accordion-inner-icon{
        .icon-wrap{
          transform: rotate(180deg);
          &::after{
            opacity: 0;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// AccordionInner.vue?1652be08